module.exports = __webpack_public_path__ + "static/green2-561440308510298cba9f7ca43feaa22d.png";